import { render } from "./CodReceiverCreate.vue?vue&type=template&id=9f39526e"
import script from "./CodReceiverCreate.vue?vue&type=script&lang=js"
export * from "./CodReceiverCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__